module.exports = __webpack_public_path__ + "static/Corporate_Responsibility_Header-a4213d3d18d779487cdc85654d27bdab.jpg";